import { render } from "./fluidBall.vue?vue&type=template&id=238a057c"
import script from "./fluidBall.vue?vue&type=script&lang=js"
export * from "./fluidBall.vue?vue&type=script&lang=js"

import "./fluidBall.vue?vue&type=style&index=0&id=238a057c&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__